export type ProfileRoleCode = 'super_admin' | 'admin' | 'agent' | 'owner' | 'tenant';

export type ProfileAccessStatus = 'active' | 'suspended' | 'disabled';

export interface GetMyActorAccessContextRpcRow {
  actor_id: string;
  role_code: ProfileRoleCode;
  access_status: ProfileAccessStatus;
  can_access: boolean;
  is_internal_operator: boolean;
  is_admin_or_super_admin: boolean;
}

export interface MyAccessContext {
  userId: string;
  email: string;
  displayName: string | null;
  avatarUrl: string | null;
  phone: string | null;
  roleCode: ProfileRoleCode;
  accessStatus: ProfileAccessStatus;
  dashboardPath: string | null;
  canAccess: boolean;
  isInternalOperator: boolean;
  isAdmin: boolean;
  isAdminOrSuperAdmin: boolean;
  isSuperAdmin: boolean;
  isAgent: boolean;
  isOwner: boolean;
  isTenant: boolean;
}

export type AccessContextErrorKind =
  | 'not_authenticated'
  | 'profile_not_found'
  | 'permission_denied'
  | 'unexpected_empty_result'
  | 'network_or_unknown';

export class AccessContextQueryError extends Error {
  readonly kind: AccessContextErrorKind;
  readonly code?: string;
  readonly details?: string | null;
  readonly hint?: string | null;
  readonly cause?: unknown;

  constructor(params: {
    kind: AccessContextErrorKind;
    message: string;
    code?: string;
    details?: string | null;
    hint?: string | null;
    cause?: unknown;
  }) {
    super(params.message);
    this.name = 'AccessContextQueryError';
    this.kind = params.kind;
    this.code = params.code;
    this.details = params.details;
    this.hint = params.hint;
    this.cause = params.cause;
  }
}

export const PROFILE_ROLE_CODE_LABELS: Record<ProfileRoleCode, string> = {
  super_admin: 'Super Administrador',
  admin: 'Administrador',
  agent: 'Agente',
  owner: 'Propietario',
  tenant: 'Inquilino',
};

export const PROFILE_ACCESS_STATUS_LABELS: Record<ProfileAccessStatus, string> = {
  active: 'Activo',
  suspended: 'Suspendido',
  disabled: 'Deshabilitado',
};

export const getAccessContextDisplayName = (
  accessContext: Pick<MyAccessContext, 'displayName' | 'email'> | null | undefined,
) => {
  const normalizedDisplayName = accessContext?.displayName?.trim();
  if (normalizedDisplayName) return normalizedDisplayName;

  const normalizedEmail = accessContext?.email?.trim();
  if (normalizedEmail) return normalizedEmail;

  return 'Usuario';
};